export default "__VITE_ASSET__B$IAa$35__"